import StyleSheetRW from "core/StyleSheetRW";
const styles = StyleSheetRW.create(() => ({
app:{ backgroundColor: "#FFFFFF66", zIndex: 1 }
,
mainFont:{ fontWeight: "700", fontSize: 32, marginTop: 20, marginLeft: 32, fontFamily: 'outfit' },
componentText:{ marginLeft: 24, fontSize: 24, fontWeight: "400" },
profileIcon:{ width: 16, height: 20 },
menuSubcription:{ width: 19, height: 16 },
timeOffIcon:{width:21,height:21},
leaveRequestIcon:{width:20,height:20},
menuIconReport:{ width: 24, height: 24 },
profileText:{ marginLeft: 20, fontSize: 24, fontWeight: "400" },
chatText:{ marginLeft: 15, fontSize: 24, fontWeight: "400" },
endText:{ marginLeft: 19, fontSize: 24, fontWeight: "400" },
signOutIcon:{ width: 24, height: 24 },
leftSpacing:{ marginLeft: 26 },
leaveDashboardIconLeft:{ marginLeft: 25 },
leaveDashboardIconMargin: {marginLeft: 21},
leaveDashboardTextMargin:{ marginLeft: 19, fontSize: 24, fontWeight: "400"  },
leftSpacingSetting:{ marginLeft: 19 },
leftSpacingSignout:{ marginLeft: 23 },
leftSpacingSecondary:{ marginLeft: 28 },
leftAlpha:{ marginLeft: 22 },
leave:{ marginLeft: 20, fontSize: 24, fontWeight: "400" },
leaveAway:{ marginLeft: 24, fontSize: 24,fontWeight: "400" },
leaveEnd:{ marginLeft: 19, fontSize: 24, fontWeight: "400" },
leaveOut:{ marginLeft: 15, fontSize: 24, fontWeight: "400" },
signOutEnd:{ marginLeft: 15, fontSize: 24, fontWeight: "400" },
setting:{ position: 'absolute', bottom: 38},
signOut:{ position: 'absolute', bottom: 5 },
settingIcon:{ width: 32, height: 32, },
menuIcon:{height:24,width:24},
settingText:{ marginBottom: 4, marginLeft: 10, fontSize: 24, fontWeight: "400" },
back:{ marginTop: 45 },
manage:{ marginLeft: 25, fontSize: 24, fontWeight: "400" },
cursor:{cursor:'pointer'},
backIcon:{ width: 13.89, height: 24 },
downIcon:{marginRight:10,width: 13.89, height: 18, transform: 'rotate(-90deg)'},
downIconOpen:{ marginRight:10,width: 13.89, height: 18, transform: 'rotate(90deg)'},
backText:{ marginLeft: 14, fontSize: 24, fontWeight: "400" },
mobile:{ width: "100vw" },
cancel:{ position: "absolute", left: 20, top: 0 },
cancelIcon:{ width: 13.89, height: 24, marginTop: 20 },
titleBig:{ fontSize: 32, fontWeight: "700" },
header:{ width: "100vw" },
cancelIconMobile:{ width: 24, height: 24, cursor: "pointer" },
mobileHome:{ marginLeft: 19, fontSize: 24, fontWeight: "400" },
menuContainer:{ height: 54, width: "100vw" },
mobileMenu:{
    width: "100vw",
    padding: 0,
    marginLeft: 0,
},
mobileSignOut:{
    fontSize: 20,
    fontWeight: "400",
    fontStyle: "Outfit",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    height: 40,
  },
  mobileSetting: {fontSize: 20,
  fontWeight: "400",
  fontStyle: "Outfit",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  height: 40,
 },
mobileView:{ height: 54, width: "100vw" },
signOutTextMobile:{ marginBottom: 4, marginLeft: 16, fontSize: 24, fontWeight: "400" },
miniMenu:{
fontSize: 20,
fontWeight: "400",
fontStyle: "Outfit",
display: "flex",
flexDirection: "row",
alignItems: "center",
height: 40,},
profileMarginLeft: { marginLeft: 28  },
homeText:{ marginLeft: 21, fontSize: 24, fontWeight: "400" },
chatCount:{position:"absolute",backgroundColor:"#2F4858",height:17,width:17,borderRadius:100,top:250,left:150,textAlign:"center",fontSize:14,color:"#ffffff",padding:"2px 0 0 0"},
}))

export default styles